import { render, staticRenderFns } from "./form_add.vue?vue&type=template&id=ac734d00&scoped=true"
import script from "./form_add.vue?vue&type=script&lang=js"
export * from "./form_add.vue?vue&type=script&lang=js"
import style0 from "./form_add.vue?vue&type=style&index=0&id=ac734d00&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac734d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac734d00')) {
      api.createRecord('ac734d00', component.options)
    } else {
      api.reload('ac734d00', component.options)
    }
    module.hot.accept("./form_add.vue?vue&type=template&id=ac734d00&scoped=true", function () {
      api.rerender('ac734d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/interview/interview_plan/form/components/form_add.vue"
export default component.exports